/**
 * Firebase web client config from Vite env (see .env.development | .env.staging | .env.production).
 * Web SDK keys are public in the client bundle; do not put server secrets here.
 */
import type { FirebaseOptions } from 'firebase/app';

function env(key: keyof ImportMetaEnv): string {
  const val = import.meta.env[key];
  if (typeof val !== 'string' || !val.trim()) {
    throw new Error(
      `Missing Firebase env ${String(key)}. Copy .env.example and set values for your environment.`
    );
  }
  return val.trim();
}

export const firebaseConfig: FirebaseOptions = {
  apiKey: env('VITE_FB_API_KEY'),
  authDomain: env('VITE_FB_AUTH_DOMAIN'),
  projectId: env('VITE_FB_PROJECT_ID'),
  storageBucket: env('VITE_FB_STORAGE_BUCKET'),
  messagingSenderId: env('VITE_FB_SENDER_ID'),
  appId: env('VITE_FB_APP_ID'),
  ...(import.meta.env.VITE_FB_MEASUREMENT_ID
    ? { measurementId: import.meta.env.VITE_FB_MEASUREMENT_ID }
    : {}),
};

/** Same as projectId; used for sanity checks and UI labels. */
export const firebaseAppName = firebaseConfig.projectId ?? 'unknown';

if (import.meta.env.DEV) {
  console.log('[Firebase] projectId:', firebaseConfig.projectId);
}
